import script from "./Identicon.vue?vue&type=script&setup=true&lang=js"
export * from "./Identicon.vue?vue&type=script&setup=true&lang=js"

import "./Identicon.vue?vue&type=style&index=0&id=2b69d540&scoped=true&lang=css"
script.__scopeId = "data-v-2b69d540"

export default script